import { clearStore } from "@faro-lotv/project-source";
import { createSlice } from "@reduxjs/toolkit";
import { fetchCapturedData } from "@store/captured-data/captured-data-slice-thunk";

/** State of the captured data of the selected project */

const initialState = Object.freeze({
  captures: [],
  areas: [],
  fetchingStatus: "uninitialized"
});
const capturedDataSlice = createSlice({
  name: "capturedData",
  initialState,
  reducers: {
    resetCapturedDataState: () => initialState
  },
  extraReducers(builder) {
    builder.addCase(fetchCapturedData.pending, state => {
      state.fetchingStatus = "pending";
    }).addCase(fetchCapturedData.fulfilled, (state, action) => {
      state.captures = action.payload.captures;
      state.areas = action.payload.areas;
      state.fetchingStatus = "succeeded";
    }).addCase(fetchCapturedData.rejected, (state, action) => {
      // An aborted request is not an error, so the data can be fetched again
      state.fetchingStatus = action.meta.aborted ? "uninitialized" : "rejected";
    })
    // Cleared together with the iElements when the user leaves the project
    .addCase(clearStore, () => initialState);
  }
});
export const {
  resetCapturedDataState
} = capturedDataSlice.actions;
export const capturedDataReducer = capturedDataSlice.reducer;